
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ashtavinayakdarshancab() {



    const cardData =
    {
        keyword: 'Ashtavinayak Darshan Cab',
        heading: 'Platinum24 Cabs: Ashtavinayak Darshan Cab',
        headingDescription: '  Platinum24 Cabs offers reliable Ashtavinayak Darshan Cab services, making your spiritual journey across the eight sacred Ganesh temples of Maharashtra smooth and comfortable. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a hassle-free pilgrimage with ample space and comfort for families and groups. With professional drivers well-versed in the temple routes, we guarantee timely darshan at each shrine and safe travel throughout the circuit. Whether you’re planning a one-day or multi-day itinerary, Platinum24 Cabs provides affordable packages, punctual service, and a spiritually enriching travel experience for your Ashtavinayak Darshan.',

        top: 'Top Places to Visit in Ashtavinayak with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shree Mayureshwar Temple – Morgaon",
    "description": "The Mayureshwar Temple at Morgaon is considered the starting and ending point of the Ashtavinayak Yatra. Dedicated to Lord Ganesha in the form of Mayureshwar riding a peacock, it was built in the 14th century. The temple’s architecture is inspired by Mughal style with beautiful stone carvings. Pilgrims believe a darshan here removes all obstacles. Surrounded by four gates symbolizing the four directions, it represents Ganesha’s universal presence. Morgaon is the spiritual gateway of the Ashtavinayak journey."
  },
  {
    "title": "Shree Siddhivinayak Temple – Siddhatek",
    "description": "Located on the banks of the Bhima River, the Siddhatek temple is dedicated to Siddhivinayak, the Ganesha who grants spiritual power and success. It is believed that Lord Vishnu himself performed penance here. The temple is surrounded by scenic hills and requires climbing 250 steps. Devotees say wishes made here come true with faith. The temple’s peaceful setting makes it ideal for meditation and prayer. Siddhatek is the powerful spiritual stop of the Ashtavinayak circuit."
  },
  {
    "title": "Shree Ballaleshwar Temple – Pali",
    "description": "Ballaleshwar Temple in Pali is the only Ganesha temple named after a devotee, Ballal. Built in the 17th century, it is known for its unique east-facing idol that glows with the morning sun. The temple’s architecture is designed so that the first rays of the sun fall directly on the idol. Devotees believe Ganesha here blesses true devotion and selfless service. The temple also has a lake called Dhundi Vinayak. Ballaleshwar is Ashtavinayak’s temple of pure devotion."
  },
  {
    "title": "Shree Varadvinayak Temple – Mahad",
    "description": "Varadvinayak Temple at Mahad is known for granting boons and fulfilling wishes. The temple is small yet powerful, with a self-manifested idol (swayambhu) of Lord Ganesha. Unlike other temples, devotees can directly touch and worship the idol here. The temple pond and lamp burning continuously since 1892 add to its charm. Pilgrims believe sincere prayers here bring prosperity and happiness. Varadvinayak is Ashtavinayak’s temple of blessings and fulfillment."
  },
  {
    "title": "Shree Chintamani Temple – Theur",
    "description": "Theur’s Chintamani Temple is associated with the legend of Ganesha bringing peace of mind (chinta-mani) to sage Kapila. It is one of the largest temples in the Ashtavinayak circuit, built during the Peshwa era. The idol is adorned with precious jewels and ornaments. Pilgrims visit to seek relief from worries and mental stress. Theur is located close to Pune, making it a busy pilgrimage spot. Chintamani Temple is Ashtavinayak’s shrine of wisdom and tranquility."
  },
  {
    "title": "Shree Girijatmaj Temple – Lenyadri",
    "description": "The Girijatmaj Temple at Lenyadri is unique as it is located inside a Buddhist rock-cut cave. Dedicated to Ganesha as the son of Goddess Parvati (Girija), it requires climbing 307 steps. The cave-temple offers a panoramic view of surrounding hills and valleys. It is believed Parvati performed penance here to be blessed with Ganesha. The atmosphere inside the cave is serene and mystical. Girijatmaj is Ashtavinayak’s temple of divine motherhood."
  },
  {
    "title": "Shree Vighneshwar Temple – Ozar",
    "description": "Vighneshwar Temple in Ozar is dedicated to Lord Ganesha as the remover of obstacles (Vighnaharta). The temple is built in stone with a golden dome and deepmalas (lamp towers). Its sanctum houses a swayambhu idol adorned with jewels. Pilgrims believe darshan here ensures success in new ventures. Ozar also hosts grand celebrations during Ganesh Chaturthi. Vighneshwar is Ashtavinayak’s shrine of victory and protection."
  },
  {
    "title": "Shree Mahaganapati Temple – Ranjangaon",
    "description": "The Mahaganapati Temple at Ranjangaon is the most powerful among the Ashtavinayak shrines. The idol is larger than life, with eight trunks and ten arms, though usually only the smaller visible form is worshipped. It is believed that Lord Shiva himself prayed to Ganesha here before fighting Tripurasura. The temple’s grandeur and spiritual power attract thousands of pilgrims daily. Mahaganapati is the final stop of the Ashtavinayak Yatra, symbolizing completion and blessings."
  }
],



"services": [
    {
      "name": "Cab for Ashtavinayak Darshan",
      "description": "Book a reliable cab for Ashtavinayak Darshan from Pune and visit all eight Ganpati temples in comfort. Ideal for families and devotees seeking a peaceful pilgrimage experience."
    },
    {
      "name": "Ashtavinayak Darshan Package from Pune",
      "description": "All-inclusive Ashtavinayak Darshan package from Pune covering transportation, tolls, and driver charges. Choose from multiple vehicle options suited for solo, family, or group tours."
    },
    {
      "name": "Ashtavinayak Darshan from Pune in 2 Days",
      "description": "Perfectly planned 2-day Ashtavinayak Darshan tour from Pune including a comfortable vehicle, experienced driver, and time-optimized itinerary for a hassle-free spiritual trip."
    },
    {
      "name": "Pune to Ashtavinayak Taxi Service",
      "description": "Reliable and comfortable taxi service from Pune to Ashtavinayak temples, ensuring a safe and timely journey with courteous chauffeurs familiar with the entire route."
    },
    {
      "name": "Pune to Ashtavinayak Tour Package",
      "description": "Comprehensive Ashtavinayak tour packages from Pune featuring round-trip transport, sightseeing stops, and options for same-day or multi-day darshan schedules."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Package",
      "description": "Affordable darshan packages from Pune to all eight Ashtavinayak temples, with customizable travel plans and flexible pickup/drop options across the city."
    },
    {
      "name": "Cheapest Ashtavinayak Tour from Pune",
      "description": "Budget-friendly Ashtavinayak darshan tours from Pune with no compromise on safety or comfort. Ideal for small families, senior citizens, and spiritual groups."
    },
    {
      "name": "Cheapest Tempo Traveller for Ashtavinayak Tour from Pune",
      "description": "Economical tempo traveller rentals from Pune for Ashtavinayak Yatra, suitable for groups and large families seeking spacious and comfortable transport."
    },
    {
      "name": "Pune to Ashtavinayak Cab",
      "description": "Convenient cab services from Pune to Ashtavinayak temples, offering hatchbacks, sedans, and SUVs with professional drivers for a smooth pilgrimage."
    },
    {
      "name": "Ashtavinayak Yatra Tour Cabs",
      "description": "Specialized cabs for Ashtavinayak Yatra from Pune with route-knowledgeable drivers and flexible itinerary options for temple visits and breaks."
    },
    {
      "name": "Pune to Ashtavinayak Tempo Traveller on Rent",
      "description": "Spacious tempo travellers on rent from Pune to Ashtavinayak for large groups. Features include AC, comfortable seats, and professional drivers familiar with the pilgrimage circuit."
    },
    {
      "name": "Pune to Ashtavinayak Mini Bus on Rent",
      "description": "Mini bus rentals from Pune for Ashtavinayak tours offering ample seating and a comfortable ride, perfect for larger groups and society tours."
    },
    {
      "name": "Pune to Ashtavinayak 17 Seater Bus on Rent",
      "description": "Hire a 17-seater bus from Pune to Ashtavinayak for a group-friendly pilgrimage experience with enough room for everyone to travel comfortably."
    },
    {
      "name": "Pune to Ashtavinayak Ertiga on Rent",
      "description": "Rent an Ertiga from Pune to Ashtavinayak for mid-sized groups or families, offering comfort, space, and a smooth journey to all eight temples."
    },
    {
      "name": "Ashtavinayak Tour from Pune by Car Package",
      "description": "Car packages for Ashtavinayak tour from Pune with options like Swift Dzire, Ertiga, Innova, and more. Fully customizable based on your darshan plan."
    },
    {
      "name": "Pune to Ashtavinayak Innova Crysta on Rent",
      "description": "Travel in style and comfort from Pune to Ashtavinayak in an Innova Crysta. Perfect for families wanting a premium experience for their spiritual journey."
    },
    {
      "name": "Pune to Ashtavinayak Taxi Fare",
      "description": "Transparent and competitive taxi fares from Pune to Ashtavinayak temples. Get detailed pricing with no hidden charges, tolls, or driver fees."
    }
  ],
  "tableData": [
    ["Cab for Ashtavinayak Darshan", "Ashtavinayak Darshan Package from Pune"],
    ["Ashtavinayak Darshan from Pune in 2 Days", "Pune to Ashtavinayak Taxi Service"],
    ["Pune to Ashtavinayak Tour Package", "Pune to Ashtavinayak Darshan Package"],
    ["Cheapest Ashtavinayak Tour from Pune", "Cheapest Tempo Traveller for Ashtavinayak Tour from Pune"],
    ["Pune to Ashtavinayak Cab", "Ashtavinayak Yatra Tour Cabs"],
    ["Pune to Ashtavinayak Tempo Traveller on Rent", "Pune to Ashtavinayak Mini Bus on Rent"],
    ["Pune to Ashtavinayak 17 Seater Bus on Rent", "Pune to Ashtavinayak Ertiga on Rent"],
    ["Ashtavinayak Tour from Pune by Car Package", "Pune to Ashtavinayak Innova Crysta on Rent"],
    ["Pune to Ashtavinayak Taxi Fare"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Affordable Ashtavinayak Darshan Cab Services",
        "WhyChoosedescription": "Platinum24 Cabs offers budget-friendly and comfortable cab rides for your spiritual journey to the Ashtavinayak temples."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicles for Pilgrimage Trips",
        "WhyChoosedescription": "Travel in comfort with our well-maintained cabs, designed to make your Ashtavinayak Darshan smooth and enjoyable."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Fleet for Your Safety",
        "WhyChoosedescription": "We maintain high hygiene standards by regularly cleaning and sanitizing all vehicles before every trip."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our professional drivers are well-versed with the Ashtavinayak temple routes, ensuring a safe and timely journey."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
        "WhyChoosedescription": "Choose from one-way, round-trip, or customized packages to suit your Ashtavinayak Darshan itinerary."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy clear, all-inclusive pricing covering fuel, tolls, and driver allowances for complete peace of mind."
    },
    {
        "WhyChooseheading": "Ideal for Group Pilgrimages, Family Trips, and Spiritual Tours",
        "WhyChoosedescription": "Our Ashtavinayak Darshan cab services cater to diverse spiritual travel needs."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
        "WhyChoosedescription": "Our dedicated team is available around the clock to assist with bookings, itinerary changes, and special requests."
    }
]
















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer Ashtavinayak Darshan cab services?',
        answer: 'Yes, Platinum24 Cabs provides comfortable and reliable cab services for Ashtavinayak Darshan tours covering all eight temples.',
    },
    {
        question: 'How can I book an Ashtavinayak Darshan cab with Platinum24 Cabs?',
        answer: 'You can easily book your Ashtavinayak Darshan cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Ashtavinayak Darshan trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to accommodate individual travelers and groups.',
    },
    {
        question: 'Are the drivers experienced with Ashtavinayak Darshan routes?',
        answer: 'Yes, our drivers are knowledgeable about the Ashtavinayak temple circuit and experienced in managing the tour efficiently.',
    },
    {
        question: 'Can I book a customized Ashtavinayak Darshan itinerary?',
        answer: 'Absolutely! We offer flexible packages allowing you to customize your pickup, drop-off, and temple visit sequence.',
    },
    {
        question: 'What is included in the fare for Ashtavinayak Darshan cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Are there safety measures in place for Ashtavinayak Darshan cab rides?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety protocols to ensure a safe and comfortable journey.',
    },
    {
        question: 'Can I hire an Ashtavinayak Darshan cab for multiple days?',
        answer: 'Yes, we offer hourly and multi-day packages to suit your pilgrimage schedule.',
    },
    {
        question: 'Does Platinum24 Cabs provide group and corporate packages for Ashtavinayak Darshan?',
        answer: 'Yes, we offer customized group and corporate travel solutions with priority support and flexible billing.',
    },
    {
        question: 'Is it possible to book an Ashtavinayak Darshan cab from Pune?',
        answer: 'Yes, Platinum24 Cabs offers Ashtavinayak Darshan cab services starting from Pune and surrounding areas.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajay Patil',
        feedback: 'Our Ashtavinayak Darshan trip with Platinum24 Cabs was seamless and comfortable. The driver was very knowledgeable about the temples.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha Shinde',
        feedback: 'Highly recommend Platinum24 Cabs for Ashtavinayak Darshan tours. Excellent service and great vehicle condition.',
        rating: 5,
    },
];

































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const ashtavinayakDarshanCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ashtavinayak Darshan Cab",
  "image": "https://www.platinum24cab.com/assets/images/ashtavinayak-darshan-cab.jpg",
  "description": "Book Ashtavinayak Darshan cab packages from Pune with Platinum24 Cabs. Affordable taxis, tempo travellers, mini buses, and luxury vehicles for your religious tour with verified drivers and 24/7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "9500",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/ashtavinayak-darshan-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>Ashtavinayak Darshan Cab | Tour Packages from Pune | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Ashtavinayak Darshan cab packages from Pune with Platinum24 Cabs. Affordable taxis, tempo travellers, mini buses, and luxury vehicles for your religious tour with verified drivers and 24/7 support."
  />
  <meta
    name="keywords"
    content="cab for ashtavinayak darshan, Ashtavinayak Darshan Package from Pune, ashtavinayak darshan from pune in 2 days, pune to ashtavinayak taxi service, Pune to Ashtavinayak Tour Package, pune to ashtavinayak darshan package, Cheapest Ashtavinayak tour from Pune, Cheapest Tempo Traveller for Ashtavinayak Tour from Pune, pune to ashtavinayak cab, Ashtavinayak Yatra Tour Cabs, pune to ashtavinayak tempo traveller on rent, pune to ashtavinayak mini bus on rent, pune to ashtavinayak 17 seater Bus on Rent, pune to ashtavinayak ertiga On Rent, ashtavinayak tour from pune by car package, pune to ashtavinayak innova Crysta on Rent, Pune to ashtvinayak taxi fare"
  />
  <script type="application/ld+json">
    {JSON.stringify(ashtavinayakDarshanCabSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/13.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Ashtavinayakdarshancab;